import { AbstractControl, ValidationErrors } from '@angular/forms';

export function whitespaceValidator({ value }: AbstractControl<string | null>): ValidationErrors | null {
  return value && !value.trim() ? { whitespace: true } : null;
}
